;(function($, undefined){
    "use strict";

    var rnn = window.rnn, log, maps, forms, Form, Field;


    function initForms(){

        function StoryForm(options){
            this.base.apply(this, arguments);
        }

        StoryForm.prototype = Object.create(Form.prototype);
        StoryForm.prototype.type = "story";
        StoryForm.prototype.constructor = StoryForm;
        StoryForm.prototype.action = rnn.site.ugcURL;
        StoryForm.prototype.validateReturn = function(data, success, error){
            data = $.parseJSON(data);
            if(!data){
                error({});
            }
            data.result === "success" ? success(data) : error(data);
        };
        StoryForm.prototype.create = function(){
            var form = this.base.prototype.create.apply(this, arguments),
                leftColumn = $($.el.div({'class':'leftColumn'})),
                rightColumn = $($.el.div({'class':'rightColumn'}));

            // Register fields with the form
            form.registerField({name: 'title', placeholder: 'Title', title: 'Title'});
            form.registerField({name: 'details', element: 'textarea', placeholder: 'Your Story...', title: 'Details'});
            form.registerField({name: 'terms_and_conditions', title: 'Terms and conditions', type:'checkbox', label:
                'I certify that I have the right to distribute these photos and I agree with the ',
                append: $.el.a({href:rnn.site.termsUrl}, 'Terms and Conditions.')
            });
            form.registerField(new rnn.modules.tags.TagsSelector({url: rnn.site.tagsURL, name:'tags', placeholder:'Add a tag', title: 'Tags', multiSelect: true, element: 'select'}));
            var imageField = rnn.modules.imageUpload.addImageFieldsTo(form, {name: 'image', title: 'Image Upload'}, {name: 'caption', title: 'Image Caption'});

            // Form context
            form.registerField(new rnn.modules.contentContext.ContentContext(), true);

            // StoryForm specific data
            form.registerField({name: 'form_type', type: 'hidden', value: 'StoryForm'}, true);

            leftColumn.append(
                form.fields.details.element,
                form.fields.tags.element
            );

            rightColumn.append(
                imageField
            );

            // Add events, and append elements to the forms element
            $(form.element)
                .addClass('storyForm')
                .append(
                    $.el.p(form.intro),
                    form.fields.title.element,
                    leftColumn,
                    rightColumn,
                    form.fields.terms_and_conditions.element
                );

            return this;
        };

        // Expose the constructor on the module.
        rnn.modules.ugc2.StoryForm = StoryForm;
    }


    // Initialise Notices
    function initUgcStories() {
        log = rnn.logging.log;
        maps = rnn.modules.maps;
        forms = rnn.modules.forms;
        Form = forms.Form;
        Field = forms.Field;

        initForms();
    }

    rnn.modules.register('ugcStories', {
        init: initUgcStories
    });

}(jQuery));
